<template>
  <div class="outmain ba_f">
    <div class="shuju_title mar_b20">
      <div class="shuju_title_text">
        <span>{{ $t('finance.withdrawal.listTitle') }}</span>
      </div>
    </div>
    <div class="flex mar_t20 mar_b20">
      <el-form :inline="true" :model="formInline" class="demo-form-inline searchform">
        <el-form-item :label="$t('finance.withdrawal.withdrawTime')" class="mar_l20">
          <el-date-picker
            v-model="formInline.timeData"
            type="daterange"
            :range-separator="$t('common.to')"
            :start-placeholder="$t('common.startDate')"
            :end-placeholder="$t('common.endDate')"
            @change="change"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('common.realName')" class="mar_l20">
          <el-input
            v-model="formInline.userName"
            size="medium"
            :placeholder="$t('rider.list.namePh')"
            @input="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch" size="medium">{{ $t('common.filter') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      v-loading="listLoading"
      :element-loading-text="loadingText"
      :data="list"
      stripe
      style="width: 100%"
      @selection-change="setSelectRows"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="userName" :label="$t('finance.withdrawal.riderName')"></el-table-column>
      <el-table-column prop="type" :label="$t('finance.withdrawal.withdrawMethod')">
        <template slot-scope="scope">
          <div v-if="scope.row.type == '1'">{{ $t('finance.withdrawal.wechat') }}</div>
          <div v-if="scope.row.type == '2'">{{ $t('finance.withdrawal.alipay') }}</div>
          <div v-if="scope.row.type == '3'">{{ $t('finance.withdrawal.unionpay') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="money" :label="$t('finance.withdrawal.withdrawAmount')">
        <template slot-scope="scope">
          <div class="flex">
            <section class="debug-d debug-small" style="background: #2a75ed;"></section>
            <span>{{ scope.row.money }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="charge" :label="$t('finance.withdrawal.fee')">
        <template slot-scope="scope">
          <div class="flex">
            <section class="debug-d debug-small" style="background: #fd5500;"></section>
            <span>{{ scope.row.charge }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="actualMoney" :label="$t('finance.withdrawal.actualAmount')">
        <template slot-scope="scope">
          <div class="flex">
            <section class="debug-d debug-small" style="background: #67c23a;"></section>
            <span>{{ scope.row.actualMoney }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('finance.withdrawal.status')">
        <template slot-scope="scope">
          <div class="flex" v-if="scope.row.state == 1">
            <section class="debug-d debug-small" style="background: #2a75ed;"></section>
            <span style="color: #2a75ed;">{{ $t('finance.withdrawal.applying') }}</span>
          </div>
          <div class="flex" v-if="scope.row.state == 2">
            <section class="debug-d debug-small" style="background: #67c23a;"></section>
            <span style="color: #67c23a;">{{ $t('finance.withdrawal.approved') }}</span>
          </div>
          <div class="flex" v-if="scope.row.state == 3">
            <section class="debug-d debug-small" style="background: #fd5500;"></section>
            <span style="color: #fd5500;">{{ $t('finance.withdrawal.rejected') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" :label="$t('finance.withdrawal.withdrawTime')"></el-table-column>
      <el-table-column :label="$t('common.operation')" align="center">
        <template slot-scope="scope" v-if="scope.row.state == '1'">
          <el-button type="text" @click="handClickOpen(scope.row.id)">{{ $t('common.view') }}</el-button>
          <el-button type="text" @click="handleEdit(scope.row, 'adopt')">{{ $t('finance.withdrawal.pass') }}</el-button>
          <el-button type="text" @click="handleEdit(scope.row, 'reject')">
            <span style="color: #fd5500;">{{ $t('finance.withdrawal.reject') }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="page.total"
      :page-size="page.size"
      :current-page.sync="page.currentPage"
      @current-change="handleCurrentChange"
    ></el-pagination>
    <el-dialog width="700px" :visible.sync="dialogVisible" :title="$t('finance.withdrawal.detail')">
      <el-form size="small" label-width="100px" label-position="left">
        <el-form-item :label="$t('finance.withdrawal.rider')">{{ continfo.userName }}</el-form-item>
        <el-form-item :label="$t('finance.withdrawal.withdrawMethod')">{{ withdrawTypeName(continfo.type) }}</el-form-item>
        <el-form-item :label="$t('finance.withdrawal.withdrawAmount')">{{ continfo.money }}</el-form-item>
        <el-form-item :label="$t('finance.withdrawal.fee')">{{ continfo.charge }}</el-form-item>
        <el-form-item :label="$t('finance.withdrawal.actualMoneyLabel')">{{ continfo.actualMoney }}</el-form-item>
        <template v-if="continfo.type == '1'">
          <el-form-item :label="$t('finance.withdrawal.payee')">
            <el-image
              v-if="continfo.account"
              style="width: 200px; cursor: pointer;"
              :src="continfo.account.wxImg"
              fit="cover"
            ></el-image>
          </el-form-item>
        </template>
        <template v-if="continfo.type == '2'">
          <el-form-item :label="$t('finance.withdrawal.payee')">
            <el-image
              v-if="continfo.account"
              style="width: 200px; cursor: pointer;"
              :src="continfo.account.aliImg"
              fit="cover"
            ></el-image>
          </el-form-item>
        </template>
        <template v-if="continfo.type == '3'">
          <el-form-item :label="$t('finance.withdrawal.bankCard')">{{ continfo.userName }}</el-form-item>
          <el-form-item :label="$t('finance.withdrawal.reservePhone')">{{ continfo.userName }}</el-form-item>
          <el-form-item :label="$t('finance.withdrawal.bankName')">{{ continfo.userName }}</el-form-item>
          <el-form-item :label="$t('finance.withdrawal.bankBranch')">{{ continfo.userName }}</el-form-item>
        </template>
        <el-form-item :label="$t('finance.withdrawal.withdrawTime')">{{ continfo.createdAt }}</el-form-item>
      </el-form>
      <el-button size="small" @click="handleEdit(continfo, 'adopt')">{{ $t('finance.withdrawal.pass') }}</el-button>
      <el-button size="small" @click="handleEdit(continfo, 'reject')">
        <span style="color: red;">{{ $t('finance.withdrawal.reject') }}</span>
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
import { widthdrawalList, withdrawalOperation, getwidthdrawal } from '@/api/finance';
export default {
  data() {
    return {
      dialogVisible: false,
      formInline: {
        timeData: '',
        userName: '',
      },
      list: [],
      listLoading: true,
      page: {
        total: 0,
        size: 10,
        currentPage: 1,
      },
      continfo: {},
      selectParmse: {
        page: 1,
        startAt: null,
        endAt: null,
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    withdrawTypeName(type) {
      const map = {
        1: this.$t('finance.withdrawal.wechat'),
        2: this.$t('finance.withdrawal.alipay'),
        3: this.$t('finance.withdrawal.unionpay'),
      };
      return map[type] || map[String(type)] || '';
    },
    setSelectRows() {},
    handClickOpen(id) {
      this.dialogVisible = true;
      getwidthdrawal({ id }).then((res) => {
        if (res.code == 1) {
          this.continfo = res.data;
        }
      });
    },
    handleEdit(row, type) {
      this.$baseConfirm(this.$t('confirm.executeAction'), null, async () => {
        const { msg } = await withdrawalOperation({ id: row.id, type });
        this.$baseMessage(msg, 'success');
        this.dialogVisible = false;
        this.fetchData();
      });
    },
    change(e) {
      if (e && e.length === 2) {
        this.selectParmse.startAt = e[0].getTime() / 1000;
        this.selectParmse.endAt = e[1].getTime() / 1000;
      }
    },
    onSearch() {
      this.fetchData();
    },
    async fetchData() {
      this.selectParmse.page = this.page.currentPage;
      if (this.formInline.userName) {
        this.selectParmse.userName = this.formInline.userName;
      } else {
        delete this.selectParmse.userName;
      }
      const { data, count } = await widthdrawalList(this.selectParmse);
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
